import * as React from "react";
import { MobXProviderContext } from "mobx-react";

const useBasicStores = <PortalRootStore>(): PortalRootStore => React.useContext(MobXProviderContext).rootStore;

export default useBasicStores;
